(() => {
  const settingsElement = document.getElementById('hs-seo-settings');
  const main = document.getElementById('MainContent');
  if (!settingsElement || !main || main.dataset.hsSeoReady) return;
  const config = JSON.parse(settingsElement.textContent);
  const context = `${config.title} ${config.handle}`;
  const topics = globalThis.HsSeoTopics;
  const media = globalThis.HsSeoMedia;
  if (!topics || !media) return;
  const pageTopic = topics.classify(context);
  const isAccessory = pageTopic.accessory;
  const productsFor = kind => {
    const handles = media.productKinds[kind] || [];
    return handles.map(handle => media.products.find(product => product.handle === handle)).filter(Boolean);
  };
  const pageProducts = productsFor(pageTopic.kind);
  const shippingLinks = isAccessory ? [...main.querySelectorAll('a[href]')].filter(link => {
    const path = new URL(link.href, location.origin).pathname;
    return /\/pages\/(kostenlos-einsenden|defektes-gerat-einsenden-so-einfach-geht-s)$|\/products\/einsenden$/.test(path) || /ger[aä]t.*einsenden|kostenlos.*einsenden|einsendeservice/i.test(link.textContent);
  }) : [];
  for (const link of shippingLinks) link.dataset.hsSeoRemoved = 'shipping';
  const originalText = node => {
    const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, {
      acceptNode(text) {
        return text.parentElement?.closest('script,style,template,[data-hs-seo-added],[data-hs-seo-removed]') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      }
    });
    let result = '';
    while (walker.nextNode()) result += walker.currentNode.nodeValue;
    return result.replace(/\s+/g, ' ').trim();
  };
  const before = originalText(main);
  for (const link of shippingLinks) link.remove();
  let imageCount = 0;
  const usedPhotos = new Set();
  const addImage = (panel, heading, fallback = false) => {
    if (imageCount >= 4 || panel.querySelector('img,video,iframe,form')) return;
    const selection = topics.selectPhoto(context, heading, fallback);
    if (!selection) return;
    let photo;
    let key;
    let product;
    if (selection.productKind) {
      product = productsFor(selection.productKind)[0] || pageProducts[0];
      if (!product?.image) return;
      key = product.handle;
      photo = { url: product.image, alt: product.title, width: product.width, height: product.height };
    } else {
      key = selection.key;
      photo = media.photos[key];
    }
    if (!photo || usedPhotos.has(key)) return;
    const figure = document.createElement('figure');
    figure.className = 'hs-seo-figure';
    figure.dataset.hsSeoAdded = 'image';
    const img = document.createElement('img');
    const imageUrl = width => {
      const url = new URL(photo.url);
      url.searchParams.set('width', String(width));
      return url.href;
    };
    img.src = imageUrl(1200);
    img.srcset = [480, 800, 1200].map(width => `${imageUrl(width)} ${width}w`).join(', ');
    img.sizes = '(max-width: 749px) calc(100vw - 64px), 44vw';
    img.alt = photo.alt;
    img.loading = imageCount === 0 ? 'eager' : 'lazy';
    img.decoding = 'async';
    img.width = photo.width || 1200;
    img.height = photo.height || 800;
    img.dataset.hsSeoPhoto = key;
    if (product) {
      const link = document.createElement('a');
      link.href = product.url;
      link.append(img);
      figure.append(link);
    } else figure.append(img);
    panel.append(figure);
    panel.classList.add('hs-seo-has-image');
    if (imageCount % 2 === 1) panel.classList.add('hs-seo-reverse');
    imageCount++;
    usedPhotos.add(key);
  };
  const actions = bottom => {
    const wrapper = document.createElement('div');
    wrapper.className = `hs-seo-actions${bottom ? ' hs-seo-bottom-actions' : ''}`;
    wrapper.dataset.hsSeoAdded = 'actions';
    const links = isAccessory
      ? pageProducts.map(product => [pageProducts.length === 1 ? config.product : product.title, product.url, false])
      : [[config.send, '/pages/kostenlos-einsenden', false]];
    links.push([config.contact, '/pages/kontakt', true]);
    for (const [text, url, secondary] of links) {
      const link = document.createElement('a');
      link.textContent = text;
      link.href = url;
      link.className = `hs-seo-button${secondary ? ' hs-seo-button-secondary' : ''}`;
      wrapper.append(link);
    }
    return wrapper;
  };
  const roots = [...main.querySelectorAll('.main-page-title')].map(title => title.parentElement.querySelector('.rte')).filter(root => root && (root.textContent.trim() || root.querySelector('img,video,iframe,form')));
  if (!roots.length) {
    for (const root of main.querySelectorAll('.rte')) {
      if (root.querySelector('h2') && !root.closest('form')) roots.push(root);
    }
  }
  for (const section of main.querySelectorAll('[id*="__custom_liquid"]')) {
    const surface = [...section.children].find(node => node.matches('div,section,article') && node.querySelector('h2'));
    if (surface && !surface.closest('form') && !roots.some(root => root.contains(surface) || surface.contains(root))) roots.push(surface);
  }
  const title = main.querySelector('.main-page-title') || main.querySelector('h1');
  if (title) title.after(actions(false));
  else if (roots[0]) roots[0].before(actions(false));
  for (const root of roots) {
    root.classList.add('hs-seo-source');
    for (const shell of root.children) {
      if (shell.matches('div,section,article') && shell.querySelector('h2')) shell.classList.add('hs-seo-legacy-shell');
    }
    const parents = [...new Set([...root.querySelectorAll('h2')].map(h => h.parentElement))].filter(parent => !parent.closest('form,table,details,.hs-seo-panel'));
    for (const parent of parents) {
      if (parent !== root) parent.classList.add('hs-seo-group');
      const directHeadings = [...parent.children].filter(node => node.tagName === 'H2');
      for (const heading of directHeadings) {
        if (heading.closest('.hs-seo-panel')) continue;
        const nodes = [];
        let node = heading;
        while (node && (node === heading || node.nodeType !== Node.ELEMENT_NODE || node.tagName !== 'H2')) {
          nodes.push(node);
          node = node.nextSibling;
        }
        const panel = document.createElement('section');
        panel.className = 'hs-seo-panel';
        const copy = document.createElement('div');
        copy.className = 'hs-seo-copy';
        heading.before(panel);
        for (const original of nodes) copy.append(original);
        panel.append(copy);
        addImage(panel, heading.textContent);
      }
    }
    if (!root.querySelector('.hs-seo-panel')) {
      const panel = document.createElement('section');
      panel.className = 'hs-seo-panel';
      const copy = document.createElement('div');
      copy.className = 'hs-seo-copy';
      while (root.firstChild) copy.append(root.firstChild);
      panel.append(copy);
      root.append(panel);
      addImage(panel, config.title, true);
    } else if (!imageCount) {
      addImage(root.querySelector('.hs-seo-panel'), config.title, true);
    }
    root.after(actions(true));
  }
  for (const section of main.querySelectorAll('[id*="__custom_liquid"]')) {
    const surface = [...section.children].find(node => node.matches('div,section,article') && node.querySelector('h2'));
    if (surface && !surface.querySelector('form')) surface.classList.add('hs-seo-existing-layout');
    for (const container of section.querySelectorAll('div,section,article,header')) {
      if (container.closest('form') || !container.querySelector('h1,h2')) continue;
      if (parseFloat(getComputedStyle(container).maxWidth) >= 700) container.classList.add('hs-seo-wide-container');
    }
  }
  if (!roots.length) main.append(actions(true));
  for (const link of main.querySelectorAll('a[href]')) {
    const path = new URL(link.href, location.origin).pathname;
    if (link.closest('[data-hs-seo-added]') || link.querySelector('img') || !link.textContent.trim()) continue;
    if (path === '/pages/kostenlos-einsenden' || path === '/pages/kontakt') {
      link.classList.add('hs-seo-button');
      if (path === '/pages/kontakt') link.classList.add('hs-seo-button-secondary');
    }
  }
  main.dataset.hsSeoTextPreserved = String(before === originalText(main));
  main.dataset.hsSeoImageCount = String(imageCount);
  main.dataset.hsSeoAccessory = String(isAccessory);
  main.dataset.hsSeoRevision = '20261008-products-topics';
  main.dataset.hsSeoReady = 'true';
})();

